import styled from 'styled-components'

type AvatarWrapperProps = {
  small: boolean
}

export const AuthorName = styled.strong`
  &:hover {
    color: var(--blue) !important;
  }
`

AuthorName.displayName = 'AuthorName'

export const AvatarWrapper = styled.div<AvatarWrapperProps>`
  margin-top: ${({ small }) => (small ? '0.625rem' : '0.375rem')};
`

AvatarWrapper.displayName = 'Avatar'

export const Wrapper = styled.div`
  &:last-child {
    border-bottom: none !important;
  }
`

Wrapper.displayName = 'Wrapper'

export const CommentContent = styled.div`
  width: calc(100% - 3.125rem);
`

CommentContent.displayName = 'CommentContent'

export const CommentText = styled.p`
  overflow-wrap: anywhere;

  a {
    color: var(--blue) !important;

    &:hover {
      text-decoration: underline !important;
    }
  }
`

CommentText.displayName = 'CommentText'
